module.exports = __webpack_public_path__ + "static/media/backpack-man.800e39fd.svg";